var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('NavBar',{attrs:{"mode":_vm.navbarMode,"active-menu":_vm.activeMenu},on:{"navigate":_vm.handleNavigate}}),_c('div',{staticClass:"layout__content"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }